module.exports = __webpack_public_path__ + "static/media/dashboard-social.e213d2b1.png";